import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { map, keys } from 'lodash';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SVGColCard from '../SVGColCard';

import { GRAPH_ELEMENTS } from '../../../modules/graphic-elements';

const BUTTON_STYLE = {
  border: '1px solid rgba(0,0,0,.125)',
  background: '#fff',
  color: '#212529'
};

const RowSlider = ({ familyProperties, onGraphHover, onGraphClick }) => {
  const [cardIndex, handleCardIndex] = useState(0);
  return (
    <Row className="my-2">
      <Col xs={1} className="pr-1">
        {cardIndex > 0 && (
          <Button
            style={BUTTON_STYLE}
            className="w-100 h-100"
            onClick={() => handleCardIndex(cardIndex - 1)}
          >
            <FontAwesomeIcon icon="chevron-left" size="lg" />
          </Button>
        )}
      </Col>
      <Col xs={10}>
        <Row>
          {map(keys(familyProperties), (key, index) => {
            if (index < cardIndex || index >= cardIndex + 3) return '';
            const { humanValue } = GRAPH_ELEMENTS.properties[key];
            return (
              <SVGColCard
                key={key}
                title={humanValue}
                onGraphHover={onGraphHover}
                name={key}
                onClick={() => onGraphClick(key)}
              >
                {familyProperties[key]}
              </SVGColCard>
            );
          })}
        </Row>
      </Col>
      <Col xs={1} className="pl-1">
        {cardIndex < keys(familyProperties).length - 3 && (
          <Button
            style={BUTTON_STYLE}
            className="w-100 h-100"
            onClick={() => handleCardIndex(cardIndex + 1)}
          >
            <FontAwesomeIcon icon="chevron-right" size="lg" />
          </Button>
        )}
      </Col>
    </Row>
  );
};

RowSlider.propTypes = {
  familyProperties: PropTypes.object.isRequired,
  onGraphHover: PropTypes.func.isRequired,
  onGraphClick: PropTypes.func.isRequired
};

export default RowSlider;
